<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

(function() {
  // 1. Store the original title of the page
  const originalTitle = document.title;

  // 2. Define your "come back" messages. 
  // You can add or remove any messages from this list.
  const messages = [
    "We miss you! 😢",
    "Come back to Wigy Hair!",
    "Find your confidence...",
    "Your perfect hair is waiting...",
    "Don't forget your 100% human hair!"    
    // --- Other ideas ---
    // "Hey, come back! 👋"
    // "Your cart is waiting for you!"
    // "Find your confidence..."
    // "Don't miss out!"
  ];

  let messageIndex = 0;
  let intervalId = null;

  // 3. Function to handle the title change
  function handleVisibilityChange() {
    // When the tab is hidden
    if (document.hidden) {
      // Start cycling through messages
      intervalId = setInterval(() => {
        document.title = messages[messageIndex];
        messageIndex = (messageIndex + 1) % messages.length; // Loop through messages
      }, 2000); // Change message every 2 seconds
    } 
    // When the tab is visible again
    else {
      // Stop the cycle and restore the original title
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      document.title = originalTitle;
      messageIndex = 0; // Reset message index
    }
  }

  // 4. Add the event listener to detect tab changes
  document.addEventListener('visibilitychange', handleVisibilityChange);
})();

document.querySelectorAll(".wigy-faq-question").forEach(btn=>{
  btn.addEventListener("click",()=>{
    const item=btn.parentElement;
    item.classList.toggle("active");
  });
});